export default __webpack_public_path__ + "static/media/basket-blue.aa8dcfda.svg";